<template>
    <el-dialog
        v-loading.fullscreen.lock="loading"
        :visible.sync="evaluateVisible"
        :show-close="false"
        center
        width="420px"
        :before-close="handleClose">
        <div class="evaluate">
            <div class="evaluate_title">评价</div>
            <div class="evaluate_drive">
                <!-- <img :src="$imgUrl + details.driver_info.avatar" alt=""> -->
                <img src="../../../assets/user_image.jpeg" alt="">
                <div class="evaluate_drive_msg">
                    <div class="evaluate_drive_msg_title">{{details.driver_info.username}}</div>
                    <div class="evaluate_drive_msg_mark" v-if="details.delivery_type == 1">
                        {{details.driver_info.vehicle_type}} | 车长{{details.driver_info.vehicle_length}}m | {{details.driver_info.vehicle_model_number ? details.driver_info.vehicle_model_number.join('、') : ''}}
                    </div>
                </div>
            </div>
            <div class="evaluate_line"></div>
            <div v-if="!evaluateData">
                <div class="evaluate_score">
                    <div class="evaluate_score_title">司机服务评价</div>
                    <div class="evaluate_score_list">
                        <img v-for="(item,index) in selectNum" :key="index" @click="selectNum = index + 1" src="../../../assets/order/ic_star.png" alt="">
                        <img v-for="(item,index) in 5 - selectNum" :key="index + 5"  @click="selectNum = selectNum + index + 1" src="../../../assets/order/ic_star_no.png" alt="">
                        <span>点击评分</span>
                    </div>
                </div>
                <el-input type="textarea" v-model="value" size="small" resize="none" rows="5" placeholder="快来评价一下司机服务吧"></el-input>
                <div class="evaluate_line"></div>
                <div class="evaluate_img">
                    <div class="evaluate_img_item" v-if="imgList.length < 3">
                        <uploadImage :img="img" @imgUpload="imgUpload"></uploadImage>
                    </div>
                    <div class="evaluate_img_item"  @mouseover="selectIconIndex = index" @mouseleave="selectIconIndex = -1" v-for="(item,index) in imgList" :key="index">
                        <img :src="$imgUrl + item" alt="">
                        <img v-if="index != selectIconIndex" class="evaluate_img_item_icon1" src="../../../assets/img_done.png" alt="">
                        <img v-else class="evaluate_img_item_icon1" @click="deleteImg(index)" src="../../../assets/img_delete.png" alt="">
                    </div>
                </div>
            </div>
            <div v-else>
                <div class="evaluate_score">
                    <div class="evaluate_score_title">司机服务评价</div>
                    <div class="evaluate_score_list">
                        <img v-for="(item,index) in evaluateData.comment.star" :key="index" src="../../../assets/order/ic_star.png" alt="">
                        <img v-for="(item,index) in 5 - evaluateData.comment.star" :key="index + 50"  src="../../../assets/order/ic_star_no.png" alt="">
                    </div>
                </div>
                <p style="color:#333;line-height:20px">{{evaluateData.comment.content}}</p>
                <div class="evaluate_line"></div>
                <div class="evaluate_img">
                    <div class="evaluate_img_item"  v-for="(item,index) in evaluateData.comment.imageurl" :key="index + 20">
                        <img :src="$imgUrl + item" alt="">
                    </div>
                </div>
            </div>
            <div class="evaluate_action">
                <el-button v-if="!evaluateData" type="primary" @click="submit">发表评论</el-button>
                <el-button v-else type="primary" @click="handleClose">关闭</el-button>
            </div>
        </div>
        

    </el-dialog>
   
</template>

<script>
import uploadImage from '../../../components/uplaodImage'
export default {
    props:["evaluateVisible","details","evaluateData"],
   data (){
       return {
           value:'',
           img:require('../../../assets/upload.png'),
           imgList:[],
           selectIconIndex:'',
           loading:false,
           selectNum:5
       }
   },
   components: {
       uploadImage
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       deleteImg(index){
           this.imgList.splice(index,1);
       },
       imgUpload(data){
           this.imgList.push(data.image_path);
       },
       submit(){
           this.loading = true;
           this.$post('OrderComment',{id:this.details.uuid,content:this.value,imageurl:this.imgList,star:this.selectNum})
            .then(data => {
                this.loading = false;
                this.$message.success('提交评论成功！');
                this.$emit("evaluateCallback");
                this.$emit("update:evaluateVisible",false)
            }, error => {
                this.loading = false;
                this.$message.error(error);
            });
       },
       handleClose(){
            this.$emit("update:evaluateVisible",false)   
       }
   },
   created() {
       console.log(this.details);
   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.evaluate{
    &_drive{
        display: flex;
        align-items: center;
        img{
            width:62px;
            height: 62px;
            border-radius: 31px;
            margin: 0 12px 0 10px;
        }
        &_msg{
            &_title{
                font-size: 16px;
                color:#333;
                font-weight: 500;
                line-height: 22px;
            }
            &_mark{
                font-size: 12px;
                margin-top:10px;
                line-height: 17px;
                color:#999999;
            }
        }
    }
    &_score{
        display: flex;
        justify-content: space-between;
        margin:12px 0 14px 0;
        &_title{
            font-size: 14px;
            color:#333;
            line-height: 25px;

        }
        &_list{
            display: flex;
            align-items: center;
            img{
                width:25px;
                height: 25px;
                cursor: pointer;
                margin-right: 6px;
            }
            span{
                margin-left:4px;
                font-size: 14px;
                color:#999999;
                line-height: 25px;
            }
        }
    }
    &_title{
        font-size: 20px;
        color:#333;
        font-weight: 500;
        text-align: center;
        margin-bottom:20px;
    }
    &_line{
        border-top:1px solid #E5E5E5;
        height: 1px;
        width:100%;
        margin:16px 0 16px 0; 
    }
    &_img{
        display: flex;
        &_item{
            margin-right:10px;
            position: relative;
            cursor: pointer;
            img{
                width:95px;
                height: 95px;
            }
            img.evaluate_img_item_icon1{
                width:24px;
                height: 24px;
                position: absolute;
                right: 0;
                top:0;
                cursor: pointer;
            }
        }
    }
    &_action{
        text-align: center;
        margin-top:30px;
        /deep/ .el-button{
            width:104px;
            font-size: 16px;
            font-weight: normal;
            padding: 11px 19px;
        }
    }
    /deep/ .el-textarea__inner{
        background: #F9F9F9;
        height: 138px;
        border:none;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/orderDetails/components/evaluate.vue